/** 선물 상자 — 추천 보상 아이콘(라인). */
export function GiftIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3.5" y="8.5" width="17" height="4" rx="1" />
      <path d="M5 12.5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7M12 8.5v12" />
      <path d="M12 8.5c-1.6-3.2-5-3.6-5-1.4 0 1.3 1.6 1.4 5 1.4zM12 8.5c1.6-3.2 5-3.6 5-1.4 0 1.3-1.6 1.4-5 1.4z" />
    </svg>
  )
}
